export enum TonerTypeEnum {
    NONE = 0,
    MONO,
    COLOR,
}
